import React from 'react';
// import { MEDIA_SERVER } from '../../constants/data';
import brain from './resources/brain.png';
import sport from './resources/martial-arts-uniform.png';
import moon from './resources/full-moon-face.png';
import dumpling from './resources/dumpling.png';
import tiger from './resources/tiger.png';
import gift from './resources/wrapped-gift.png';
import mouse from './resources/mouse-face.png';
import tree from './resources/tree.png';
import heart from './resources/heart.png';
import rose from './resources/rose.png';
import alarm from './resources/alarm.png';
import snowflake from './resources/snowflake.png';
import { Achievements } from '../../constants/achievements';

import { Wrap, ImgBox } from './styles';

type Props = {
    achievement: Achievements;
    isHidden: boolean;
    left: number;
    top: number;
}

const getSrc = (achievement: Achievements) => {
    switch (achievement) {
        case Achievements.QUIZ: {
            return brain;
        }

        case Achievements.CUTE: {
            return moon;
        }

        case Achievements.CHAMPION: {
            return sport;
        }

        case Achievements.DUMPLING: {
            return dumpling;
        }

        case Achievements.HUNTER: {
            return tiger;
        }

        case Achievements.NEW_YEAR_STORY: {
            return gift;
        }

        case Achievements.WALK_MOUSE_GOAL: {
            return mouse;
        }

        case Achievements.MOUSE_FRIEND: {
            return heart;
        }

        case Achievements.NY_2024: {
            return tree;
        }

        case Achievements.ADMIN: {
            return alarm;
        }

        case Achievements.FLOWER: {
            return rose;
        }

        case Achievements.NY_2025: {
            return snowflake;
        }
    }
}

export const Achievement = ({ achievement, isHidden, top, left }: Props) => {
    return (
        <Wrap $isHidden={isHidden} $top={top} $left={left}>
            <ImgBox src={getSrc(achievement)} />
        </Wrap>
    )
}